import { useContext, useEffect } from "react";
import { EditorStoreContext } from "../store/EditorStoreContext";

/**
 * Brackets an undo gesture around a continuous interaction: while `active`
 * is true, every cell update collapses into a single undo step.
 * No-op when rendered outside an editor store (e.g. isolated tests).
 */
export const useUndoGesture = (active) => {
  const store = useContext(EditorStoreContext);

  useEffect(() => {
    if (!active || !store) return undefined;
    store.getState().beginGesture();
    return () => store.getState().endGesture();
  }, [active, store]);
};
